<template>
  <div class="pa-6">
    <div class="d-flex justify-space-between align-center mb-6">
      <div class="component-title">Điểm chuẩn & Thời gian nhập điểm</div>
    </div>
    <TimeRangeConfig class="mb-6" />
    <CutoffMarkConfig />
  </div>
</template>
<script>
import TimeRangeConfig from './time-range-config/index.vue'
import CutoffMarkConfig from './cutoff-mark-config/index.vue'
export default {
  components: {TimeRangeConfig, CutoffMarkConfig},
}
</script>
<style scoped>
.component-title {
  color: #0d47a1;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
}
</style>
